const sparePartActionEnum = Object.freeze({
    SparePartWasUsed: 0,
    SparePartWasAdded: 1
});

export const sparePartActionEnumReverse = Object.fromEntries(
    Object.entries(sparePartActionEnum).map(([k, v]) => [v, k])
);

export default sparePartActionEnum;